// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_group__gu83u {
    margin-bottom: 30px;
    /*width: 260px;*/
}

.styles_group__gu83u:not(.styles_open__FroRa) {
    --icon-color-custom: var(--light-grey);
    --icon-fill-color-custom: var(--primary-color);
}

.styles_group__gu83u.styles_open__FroRa .styles_groupIcon__e4EJu {
    transform: scaleY(-1);
    /*border-top-color: var(--primary-color);*/
}

.styles_groupHeader__zOBUl {
    display: flex;
    grid-gap: 15px;
    align-items: center;
    cursor: pointer;
    position: relative;
    padding-right: 18px;
}
.styles_groupHeader__zOBUl span {
    margin: 0;
    display: inline-block;
    /*font-size: 16px;*/
}

/*.groupHeader:after {*/
/*content: '';*/
/*position: absolute;*/
/*display: block;*/
/*width: 0;*/
/*height: 0;*/
/*border-left: 8px solid transparent;*/
/*border-right: 8px solid transparent;*/
/*border-top: 10px solid #7b848e;*/
/*right: 0;*/
/*transition:*/
/*    transform 0.2s,*/
/*    border-color 0.2s;*/
/*}*/

.styles_groupIcon__e4EJu {
    height: 15px;
    min-width: 20px;
    max-width: 20px;
    margin: auto 0;
    color: var(--primary-color);
    transition: transform 0.4s;
    padding: 0 2.5px;
}
.styles_groupContent__vkdf9 {
    /*margin-left: 16px;*/
    margin-top: 12px;
    /*width: 220px;*/
}

.styles_groupContent__vkdf9 > *:not(:last-child) {
    margin-bottom: 16px;
}

.styles_checkboxes__0zTAD > *:not(:last-child) {
    margin-bottom: 6px;
}

/*.groupContent.checkboxes,*/
.styles_btnContainer__rNoBz {
    margin-left: 30px;
}

.styles_mainInfo__n4qcw {
    /*margin-top: 380px;*/

    /*--checkbox-font-size: 16px;*/
    --checkbox-font-size: inherit;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_mainInfo__n4qcw {
        /*margin-top: 350px;*/
    }

    /*.groupIcon {*/
    /*    min-width: 25px;*/
    /*    max-width: 25px;*/
    /*}*/
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]} {
    /*.groupHeader h6 {*/
    /*    font-size: 16px;*/
    /*}*/

    .styles_groupHeader__zOBUl {
        grid-gap: 13px;
    }

    /*.groupContent.checkboxes,*/
    .styles_btnContainer__rNoBz {
        margin-left: 36px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DealTaxes/components/styles.module.css"],"names":[],"mappings":"AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB,eAAe;AACf,sBAAsB;AACtB,kBAAkB;AAClB,YAAY;AACZ,aAAa;AACb,sCAAsC;AACtC,uCAAuC;AACvC,kCAAkC;AAClC,YAAY;AACZ,cAAc;AACd,sBAAsB;AACtB,yBAAyB;AACzB,IAAI;;AAEJ;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,2BAA2B;IAC3B,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;;IAErB,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA,eAAe;IACf,uBAAuB;IACvB,uBAAuB;IACvB,IAAI;AACR;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,IAAI;;IAEJ;QACI,cAAc;IAClB;;IAEA,4BAA4B;IAC5B;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@value screen-md-max, screen-lg-min from '../../../breakpoints.css';\n\n.group {\n    margin-bottom: 30px;\n    /*width: 260px;*/\n}\n\n.group:not(.open) {\n    --icon-color-custom: var(--light-grey);\n    --icon-fill-color-custom: var(--primary-color);\n}\n\n.group.open .groupIcon {\n    transform: scaleY(-1);\n    /*border-top-color: var(--primary-color);*/\n}\n\n.groupHeader {\n    display: flex;\n    grid-gap: 15px;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n    padding-right: 18px;\n}\n.groupHeader span {\n    margin: 0;\n    display: inline-block;\n    /*font-size: 16px;*/\n}\n\n/*.groupHeader:after {*/\n/*content: '';*/\n/*position: absolute;*/\n/*display: block;*/\n/*width: 0;*/\n/*height: 0;*/\n/*border-left: 8px solid transparent;*/\n/*border-right: 8px solid transparent;*/\n/*border-top: 10px solid #7b848e;*/\n/*right: 0;*/\n/*transition:*/\n/*    transform 0.2s,*/\n/*    border-color 0.2s;*/\n/*}*/\n\n.groupIcon {\n    height: 15px;\n    min-width: 20px;\n    max-width: 20px;\n    margin: auto 0;\n    color: var(--primary-color);\n    transition: transform 0.4s;\n    padding: 0 2.5px;\n}\n.groupContent {\n    /*margin-left: 16px;*/\n    margin-top: 12px;\n    /*width: 220px;*/\n}\n\n.groupContent > *:not(:last-child) {\n    margin-bottom: 16px;\n}\n\n.checkboxes > *:not(:last-child) {\n    margin-bottom: 6px;\n}\n\n/*.groupContent.checkboxes,*/\n.btnContainer {\n    margin-left: 30px;\n}\n\n.mainInfo {\n    /*margin-top: 380px;*/\n\n    /*--checkbox-font-size: 16px;*/\n    --checkbox-font-size: inherit;\n}\n\n@media screen-md-max {\n    .mainInfo {\n        /*margin-top: 350px;*/\n    }\n\n    /*.groupIcon {*/\n    /*    min-width: 25px;*/\n    /*    max-width: 25px;*/\n    /*}*/\n}\n\n@media screen-lg-min {\n    /*.groupHeader h6 {*/\n    /*    font-size: 16px;*/\n    /*}*/\n\n    .groupHeader {\n        grid-gap: 13px;\n    }\n\n    /*.groupContent.checkboxes,*/\n    .btnContainer {\n        margin-left: 36px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"group": `styles_group__gu83u`,
	"open": `styles_open__FroRa`,
	"groupIcon": `styles_groupIcon__e4EJu`,
	"groupHeader": `styles_groupHeader__zOBUl`,
	"groupContent": `styles_groupContent__vkdf9`,
	"checkboxes": `styles_checkboxes__0zTAD`,
	"btnContainer": `styles_btnContainer__rNoBz`,
	"mainInfo": `styles_mainInfo__n4qcw`
};
export default ___CSS_LOADER_EXPORT___;
